import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { UseHrApp } from "../../../utils/context";
import AdminEditModal from "../../../components/AdminComponents/AdminModalEdit";

export default function ViewSingleEmployee(props) {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get("id");

  const { SingleEmployee,getSingleEmployee,loader } = UseHrApp();


  useEffect(() => {
    getSingleEmployee(id);
  }, []);
  return (
    <div className="min-w-screen min-h-[91vh] bg-[#f4f8fd] font-[Archivo] ">
      <div className=" p-3 md:pl-[16em] lg:pl-[16em] lg:pr-[1em] xl:pl-[17em] xl:pr-[2em] w-full pt-[1em] ">
        <div className=" w-full flex justify-between items-center">
          <p className=" font-[Archivo] lg:text-2xl font-semibold">
            Employee Data
          </p>
        </div>
        
        <div className="w-full">

<>
{loader ? (
  <div>

    </div>
):(<div className="grid md:grid-cols-2 md:grid-rows-6 lg:grid-cols-3 lg:grid-rows-2 gap-5">
      <div>
              <label htmlFor="firstname">Firstname</label>
              <p className="min-w-[80px] p-4 bord  text-black">
                {SingleEmployee.firstname}
              </p>
            </div>
            <div>
              <label htmlFor="lastname">lastname</label>
              <p className="min-w-[80px] p-4 bord">{SingleEmployee.lastname}</p>
            </div>

            <div>
              <label htmlFor="email">Email</label>

              <p className="min-w-[80px] p-4 bord">{SingleEmployee.email}</p>
            </div>

            <div>
              <label htmlFor="firstname">Contact</label>
              <p className="min-w-[80px] p-4 bord">{SingleEmployee.contact}</p>
            </div>

            <div>
              <label htmlFor="firstname">Status</label>
              <p className="min-w-[80px] p-4 bord">{SingleEmployee.status}</p>
            </div>
            {SingleEmployee.department ? (
              <div>
                <label htmlFor="firstname">Department</label>
                <p className="min-w-[80px] p-4 bord">
                  {SingleEmployee.department.name}
                </p>
              </div>
            ) : null}

            <div>
              <label htmlFor="salary">Salary</label>
              <p className="min-w-[80px] p-4 bord">{SingleEmployee.salary}</p>
            </div>

            <div>
              <label htmlFor="role">Role</label>
              <p className="min-w-[80px] p-4 bord">{SingleEmployee.role}</p>
            </div>

            <div>
              <label htmlFor="gender">Gender</label>
              <p className="min-w-[80px] p-4 bord">{SingleEmployee.gender}</p>
            </div>

            <div>
              <label htmlFor="Leave Days Left">Leave Days Left</label>
              <p className="min-w-[80px] p-4 bord">
                {SingleEmployee.leaveDaysRemaining}
              </p>
            </div>
          </div>)}
          {!loader && <AdminEditModal />}
       
          </>
        </div>
      </div>
    </div>
  );
}
